import { createSvgIcon } from '@mui/material/utils';

export const LibraryActiveIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 4V20"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M10 4V20"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M13.8101 5.49902L20.572 19.9999"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>,
  'LibraryActive',
);
